function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _effectorFileName = "/builds/gmini/front-utils/src/fetchService/fetchService.ts";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { EventEmitter } from 'events';
import { ForbiddenHttpException, ServerUnavailableException } from './exceptions';
export var FetchServiceEvent;

(function (FetchServiceEvent) {
  FetchServiceEvent["unauthorized"] = "unauthorized";
  FetchServiceEvent["server_unavailable"] = "server_unavailable";
  FetchServiceEvent["forbidden"] = "forbidden";
})(FetchServiceEvent || (FetchServiceEvent = {}));

export var FetchService = /*#__PURE__*/function (_EventEmitter) {
  _inherits(FetchService, _EventEmitter);

  var _super = _createSuper(FetchService);

  function FetchService(_config, options) {
    var _this;

    _classCallCheck(this, FetchService);

    _this = _super.call(this, options);
    _this._config = _config;

    _defineProperty(_assertThisInitialized(_this), "additionalHeaders", void 0);

    _this.additionalHeaders = {};

    _this.on(FetchServiceEvent.unauthorized, function () {
      return FetchService.globalEvents.emit(FetchServiceEvent.unauthorized);
    });

    _this.on(FetchServiceEvent.server_unavailable, function () {
      return FetchService.globalEvents.emit(FetchServiceEvent.server_unavailable);
    });

    _this.on(FetchServiceEvent.forbidden, function () {
      return FetchService.globalEvents.emit(FetchServiceEvent.forbidden);
    });

    return _this;
  }

  _createClass(FetchService, [{
    key: "_url",
    value: function _url(path) {
      return "".concat(this._config.baseUrl).concat(path);
    }
  }, {
    key: "setAdditionalHeader",
    value: function setAdditionalHeader(name, value) {
      this.setAdditionalHeaders(_defineProperty({}, name, value));
    }
  }, {
    key: "removeAdditionalHeader",
    value: function removeAdditionalHeader(name) {
      var headers = _objectSpread({}, this.additionalHeaders);

      delete headers[name];
      this.additionalHeaders = headers;
    }
  }, {
    key: "setAdditionalHeaders",
    value: function setAdditionalHeaders(headers) {
      this.additionalHeaders = _objectSpread(_objectSpread({}, this.additionalHeaders), headers);
    }
  }, {
    key: "emitNotFound",
    value: function emitNotFound() {
      this.emit(FetchServiceEvent.unauthorized);
      throw new Error(FetchServiceEvent.unauthorized);
    }
  }, {
    key: "emitUnavailable",
    value: function emitUnavailable() {
      this.emit(FetchServiceEvent.server_unavailable);
      throw new ServerUnavailableException(FetchServiceEvent.server_unavailable);
    }
  }, {
    key: "emitForbidden",
    value: function emitForbidden() {
      this.emit(FetchServiceEvent.forbidden);
      throw new ForbiddenHttpException(FetchServiceEvent.forbidden);
    }
  }, {
    key: "emitErrorByResponse",
    value: function emitErrorByResponse(response, init) {
      switch (response.status) {
        case 401:
          this.emitNotFound();
          break;

        case 403:
          {
            if (!(init !== null && init !== void 0 && init.skip403)) {
              this.emitForbidden();
            }

            break;
          }

        case 503:
          this.emitUnavailable();
      }
    }
  }, {
    key: "auth",
    value: function () {
      var _auth = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response, req, init) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(response.status === 401 && !(init !== null && init !== void 0 && init._retry) && this._config.refreshTokenFunc)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this._config.refreshTokenFunc();

              case 3:
                return _context.abrupt("return", this.get(req.path, _objectSpread(_objectSpread({}, init), {}, {
                  _retry: true
                })));

              case 4:
                return _context.abrupt("return", response);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function auth(_x, _x2, _x3) {
        return _auth.apply(this, arguments);
      }

      return auth;
    }() // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(config) {
        var _config$blobContentTy;

        var req, response, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = _objectSpread(_objectSpread({}, config), {}, {
                  url: this._url(config.path),
                  baseUrl: this._config.baseUrl
                });
                _context2.next = 3;
                return fetch(req.url, _objectSpread(_objectSpread({}, req), {}, {
                  headers: _objectSpread(_objectSpread({
                    accept: 'application/json',
                    'content-type': 'application/json'
                  }, config.headers), this.additionalHeaders),
                  body: JSON.stringify(req.body)
                }));

              case 3:
                response = _context2.sent;

                if (!(response.status === 401 && !config._retry && this._config.refreshTokenFunc)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return this._config.refreshTokenFunc();

              case 7:
                return _context2.abrupt("return", this.request(_objectSpread(_objectSpread({}, config), {}, {
                  _retry: true
                })));

              case 8:
                this.emitErrorByResponse(response);

                if (!((_config$blobContentTy = config.blobContentTypes) !== null && _config$blobContentTy !== void 0 && _config$blobContentTy.some(function (ct) {
                  var _response$headers$get;

                  return (_response$headers$get = response.headers.get('content-type')) === null || _response$headers$get === void 0 ? void 0 : _response$headers$get.includes(ct);
                }))) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 12;
                return response.blob();

              case 12:
                _context2.t0 = _context2.sent;
                _context2.t1 = req;
                _context2.t2 = response;
                return _context2.abrupt("return", {
                  data: _context2.t0,
                  req: _context2.t1,
                  res: _context2.t2
                });

              case 16:
                _context2.next = 18;
                return response.json();

              case 18:
                data = _context2.sent;
                return _context2.abrupt("return", {
                  data: data,
                  req: req,
                  res: response
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function request(_x4) {
        return _request.apply(this, arguments);
      }

      return request;
    }() // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "get",
    value: function get(path, init) {
      return this.request(_objectSpread(_objectSpread({}, init), {}, {
        method: 'GET',
        path: path
      }));
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "post",
    value: function post(path, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body, init) {
      return this.request(_objectSpread(_objectSpread({}, init), {}, {
        method: 'POST',
        path: path,
        body: body
      }));
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "delete",
    value: function _delete(path, init) {
      return this.request(_objectSpread(_objectSpread({}, init), {}, {
        method: 'DELETE',
        path: path
      }));
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "patch",
    value: function patch(path, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body, init) {
      return this.request(_objectSpread(_objectSpread({}, init), {}, {
        method: 'PATCH',
        path: path,
        body: body
      }));
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "put",
    value: function put(path, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body, init) {
      return this.request(_objectSpread(_objectSpread({}, init), {}, {
        method: 'PUT',
        path: path,
        body: body
      }));
    }
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(path, formData, _retry) {
        var req, response, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                req = {
                  method: 'POST',
                  url: this._url(path),
                  baseUrl: this._config.baseUrl,
                  path: path
                };
                _context3.next = 3;
                return fetch(req.url, _objectSpread(_objectSpread({}, req), {}, {
                  headers: _objectSpread({}, this.additionalHeaders),
                  body: formData
                }));

              case 3:
                response = _context3.sent;

                if (!(response.status === 401 && !_retry && this._config.refreshTokenFunc)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 7;
                return this._config.refreshTokenFunc();

              case 7:
                return _context3.abrupt("return", this.uploadFile(path, formData, true));

              case 8:
                this.emitErrorByResponse(response);
                _context3.next = 11;
                return response.json();

              case 11:
                data = _context3.sent;
                return _context3.abrupt("return", {
                  req: req,
                  data: data,
                  res: response
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function uploadFile(_x5, _x6, _x7) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }() // TODO auth

  }, {
    key: "downloadFile",
    value: function () {
      var _downloadFile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(path) {
        var _response$headers$get2, _contentDisposition$m;

        var requestInit, response, reader, chunks, _yield$reader$read, done, value, type, blob, contentDisposition, regex, fileName;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                requestInit = {
                  method: 'GET',
                  headers: _objectSpread(_objectSpread({}, this.additionalHeaders), {}, {
                    'Content-Type': 'application/json'
                  })
                };
                _context4.next = 3;
                return fetch(this._url(path), requestInit);

              case 3:
                response = _context4.sent;
                this.emitErrorByResponse(response);
                reader = response.body && response.body.getReader();

                if (reader) {
                  _context4.next = 8;
                  break;
                }

                throw new Error('No reader');

              case 8:
                chunks = []; // eslint-disable-next-line no-constant-condition

              case 9:
                if (!true) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 12;
                return reader.read();

              case 12:
                _yield$reader$read = _context4.sent;
                done = _yield$reader$read.done;
                value = _yield$reader$read.value;

                if (!done) {
                  _context4.next = 17;
                  break;
                }

                return _context4.abrupt("break", 20);

              case 17:
                chunks.push(value);
                _context4.next = 9;
                break;

              case 20:
                type = (_response$headers$get2 = response.headers.get('content-type')) === null || _response$headers$get2 === void 0 ? void 0 : _response$headers$get2.split(';')[0]; // Создаем новый объект blob с явным указанием MIME типов

                blob = new Blob(chunks, {
                  type: type
                });
                contentDisposition = response.headers.get('Content-Disposition'); //https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header
                // eslint-disable-next-line prefer-named-capture-group

                regex = /filename(?:(?![\n;])[\s\S])*=[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(UTF\x2D[0-9]["']*)?((["'])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\.$|(?:(?![\n;])[\s\S])*)?/;
                fileName = !!contentDisposition && ((_contentDisposition$m = contentDisposition.match(regex)) === null || _contentDisposition$m === void 0 ? void 0 : _contentDisposition$m[2]) || null;

                if (!(!fileName || !blob)) {
                  _context4.next = 27;
                  break;
                }

                throw new Error('No filename or blob');

              case 27:
                return _context4.abrupt("return", {
                  fileName: decodeURIComponent(fileName),
                  blob: blob
                });

              case 28:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function downloadFile(_x8) {
        return _downloadFile.apply(this, arguments);
      }

      return downloadFile;
    }()
  }]);

  return FetchService;
}(EventEmitter);

_defineProperty(FetchService, "globalEvents", new EventEmitter());